function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerMobileNav({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.00012 17.0625C8.49762 17.0625 7.98762 16.935 7.53762 16.6725L3.08262 14.1C2.18262 13.575 1.62012 12.6075 1.62012 11.565V6.43499C1.62012 5.39249 2.18262 4.42499 3.08262 3.89999L7.53762 1.3275C8.43762 0.802496 9.55512 0.802496 10.4626 1.3275L14.9176 3.89999C15.8176 4.42499 16.3801 5.39249 16.3801 6.43499V11.565C16.3801 12.6075 15.8176 13.575 14.9176 14.1L10.4626 16.6725C10.0126 16.935 9.50262 17.0625 9.00012 17.0625ZM9.00012 2.06248C8.69262 2.06248 8.37762 2.14499 8.10012 2.30249L3.64512 4.87498C3.09012 5.19748 2.74512 5.78999 2.74512 6.43499V11.565C2.74512 12.2025 3.09012 12.8025 3.64512 13.125L8.10012 15.6975C8.65512 16.02 9.34512 16.02 9.90012 15.6975L14.3551 13.125C14.9101 12.8025 15.2551 12.21 15.2551 11.565V6.43499C15.2551 5.79749 14.9101 5.19748 14.3551 4.87498L9.90012 2.30249C9.62262 2.14499 9.30762 2.06248 9.00012 2.06248Z",
    fill: "#080917",
    style: {
      fill: "#080917",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99994 8.81255C7.72494 8.81255 6.68994 7.77753 6.68994 6.50253C6.68994 5.22753 7.72494 4.19257 8.99994 4.19257C10.2749 4.19257 11.3099 5.22753 11.3099 6.50253C11.3099 7.77753 10.2749 8.81255 8.99994 8.81255ZM8.99994 5.31757C8.34744 5.31757 7.81494 5.85003 7.81494 6.50253C7.81494 7.15503 8.34744 7.68755 8.99994 7.68755C9.65244 7.68755 10.1849 7.15503 10.1849 6.50253C10.1849 5.85003 9.65244 5.31757 8.99994 5.31757Z",
    fill: "#080917",
    style: {
      fill: "#080917",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13.0576C11.6925 13.0576 11.4375 12.8026 11.4375 12.4951C11.4375 11.4601 10.3425 10.6126 9 10.6126C7.6575 10.6126 6.5625 11.4601 6.5625 12.4951C6.5625 12.8026 6.3075 13.0576 6 13.0576C5.6925 13.0576 5.4375 12.8026 5.4375 12.4951C5.4375 10.8376 7.035 9.48761 9 9.48761C10.965 9.48761 12.5625 10.8376 12.5625 12.4951C12.5625 12.8026 12.3075 13.0576 12 13.0576Z",
    fill: "#080917",
    style: {
      fill: "#080917",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerMobileNav);
export default __webpack_public_path__ + "static/media/customer-mobile-nav.36528e2daad8c92d7f93d4d932f09e40.svg";
export { ForwardRef as ReactComponent };